import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Margin } from 'styled-components-spacing';
import { Heading } from 'components';
import { formatDateTime } from 'helpers/date';
import { HistoryList, HistoryMeta, HistoryReason, EmptyNote } from '../Reports.styled';

/**
 * How the report travelled from draft to its current status.
 *
 * It sits at the bottom of the report screen: the Young Crew reads why a report
 * was rejected right under the answers it has to change.
 */
const StatusHistory = ({ items }) => {
  const { t } = useTranslation();

  return (
    <Margin top="32">
      <Margin bottom="12">
        <Heading size="h6">{t('page.yc.reports.form.historyTitle')}</Heading>
      </Margin>
      {items.length ? (
        <HistoryList>
          {items.map((item) => (
            <li key={item.id}>
              <strong>
                {item.oldStatusLabel
                  ? t('page.yc.reports.form.historyChange', {
                      from: item.oldStatusLabel,
                      to: item.newStatusLabel,
                    })
                  : item.newStatusLabel}
              </strong>
              <br />
              <HistoryMeta>
                {formatDateTime(item.createdAt)}
                {item.changedBy ? ` - ${item.changedBy}` : ''}
              </HistoryMeta>
              {item.reason && (
                <HistoryReason>
                  {t('page.yc.reports.form.reason', { reason: item.reason })}
                </HistoryReason>
              )}
            </li>
          ))}
        </HistoryList>
      ) : (
        <EmptyNote>{t('page.yc.reports.form.historyEmpty')}</EmptyNote>
      )}
    </Margin>
  );
};

StatusHistory.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      oldStatusLabel: PropTypes.string,
      newStatusLabel: PropTypes.string,
      reason: PropTypes.string,
      changedBy: PropTypes.string,
      createdAt: PropTypes.string,
    }),
  ),
};

StatusHistory.defaultProps = {
  items: [],
};

export default StatusHistory;
